import { useRef, useState } from 'react';
import { blobToFile } from '@/components/upload/crop-canvas';
import { useAdminVerificationPhoto } from '../hooks/use-admin-verification-photo';
import type { PhotoState } from './verification-photo-bar-parts';

export type Wired = {
  state: PhotoState;
  cropSrc: string | null;
  pending: boolean;
  inputRef: React.RefObject<HTMLInputElement | null>;
  open: () => void;
  onPicked: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onCancelCrop: () => void;
  onCommitCrop: (b: globalThis.Blob) => void;
  onConfirm: () => void;
  onClose: () => void;
};

const INITIAL: PhotoState = { file: null, preview: null };

function makeHandlers(
  set: (s: PhotoState) => void,
  setCropSrc: (s: string | null) => void
) {
  const onPicked = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const f = e.target.files?.[0];
    if (f) setCropSrc(URL.createObjectURL(f));
    e.target.value = '';
  };
  const onCommitCrop = (b: globalThis.Blob): void => {
    set({
      file: blobToFile(b, 'verification.jpg'),
      preview: URL.createObjectURL(b),
    });
    setCropSrc(null);
  };
  return { onPicked, onCancelCrop: () => setCropSrc(null), onCommitCrop };
}

export function useBar(memberId: string, onClose: () => void): Wired {
  const [state, setState] = useState<PhotoState>(INITIAL);
  const [cropSrc, setCropSrc] = useState<string | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const upload = useAdminVerificationPhoto();
  const handlers = makeHandlers(setState, setCropSrc);
  const onConfirm = (): void => {
    if (!state.file) return;
    upload.mutate({ id: memberId, file: state.file }, { onSuccess: onClose });
  };
  return {
    state,
    cropSrc,
    pending: upload.isPending,
    inputRef,
    open: () => inputRef.current?.click(),
    ...handlers,
    onConfirm,
    onClose,
  };
}
